import React from 'react';

import { OpalAuth } from '@frontend/atoms';

type Payload = {
  content: string;
  role: 'system' | 'user';
};

type PromptPayload = {
  type: string;
  payload: Payload[];
};

export type PromptQueue = {
  enqueuePrompt: (prompt: PromptPayload) => Promise<void>;
};
export type AIChatComponentProps = {
  currentUser: {
    instanceId: string;
    avatarUrl: undefined | string;
    name: string;
    operations?: string[];
  };
  storeKey: string;
  productScope: string;
  useSocketsForChat?: boolean;
  showHeaderIcons: boolean;
  sidebarAlwaysVisible: boolean;
  initialDockState: string;
  initialPrompt?: string;
  initialThreadId?: string | null;
  opalAuth?: OpalAuth;
};

export const LazyAIChatComponent = React.lazy<React.ComponentType<AIChatComponentProps>>(() =>
  // @ts-expect-error - External module import
  import('OpalChat/components')
    .then(m => ({
      default: m.AIChatComponent,
    }))
    .catch(error => {
      console.error('Failed to load OpalChat components:', error);
      return {
        default: () => <div>Chat component failed to load</div>,
      };
    })
);
